export * from './baseThemes/index.js';
export * from './fonts.js';
export const BRAND_COLOR_KEYS = [
    'primary',
    'accessibleOverPrimary',
    'accessibleOverBackground',
];
export const BACKGROUND_COLOR_KEYS = [
    'primary',
    'secondary',
    'tertiary',
    'inverse',
    'divider',
    'opacity',
    'overlay',
    'warning',
    'danger',
    'info',
    'success',
];
export const TEXT_COLOR_KEYS = [
    'primary',
    'secondary',
    'placeholder',
    'inverse',
    'inverseSecondary',
    'success',
    'successOnSurface',
    'warning',
    'warningOnSurface',
    'danger',
    'dangerOnSurface',
    'info',
    'infoOnSurface',
];
export const BORDER_COLOR_KEYS = [
    'input',
    'inputFocused',
    'danger',
    'success',
    'warning',
    'info',
];
export const BOX_SHADOW_KEYS = ['control'];
export const THEME_NAMES = ['opal'];
export const BRIGHTNESS_PALETTES = ['light', 'dark'];
export const UX_COLOR_SYSTEMS = [
    'success',
    'warning',
    'danger',
    'info',
];
export const BASIC_COLOR_TYPES = [
    'red',
    'orange',
    'green',
    'blue',
    'gray',
];
export const FULL_COLOR_TYPES = ['neutral'];
export const BASIC_PALETTE_KEYS = [100, 200, 300, 400];
export const FULL_PALETTE_KEYS = [
    ...BASIC_PALETTE_KEYS,
    500,
    550,
    600,
    700,
    800,
    900,
];
export const PALETTE_KEYS = BASIC_COLOR_TYPES.reduce((topAcc, color) => [
    ...topAcc,
    ...BASIC_PALETTE_KEYS.reduce((acc, key) => [...acc, `${color}.${key}`], []),
], []);
export const FONTS = [
    'Abril Fatface',
    'Archivo Narrow',
    'Cabin',
    'Poppins',
    'DM Sans',
    'Manrope',
    'Playfair Display',
    'IBM Plex Sans',
    'Oswald',
    'Cardo',
    'Nunito',
    'Noto Serif Display',
    'Raleway',
    'Inter',
    'Geist',
    'Source Serif 4',
    'Montserrat',
    'Lora',
    'Roboto',
    'Merriweather',
    'Bebas Neue',
    'Unbounded',
    'Teko',
    'BBH Hegarty',
    'Michroma',
    'Pacifico',
    'Lobster',
    'Chicle',
    'Anton',
    'GFS Neohellenic',
    'Cinzel',
    'Lobster Two',
    'Permanent Marker',
    'Prata',
    'Viga',
    'Chango',
    'Macondo',
    'Homemade Apple',
    'Lemonada',
    'Shantell Sans',
    'Crushed',
    'Boogaloo',
    'Coiny',
    'Concert One',
    'Rajdhani',
    'Solway',
    'Graduate',
    'Alfa Slab One',
    'Jura',
    'UnifrakturMaguntia',
    'Grenze Gotisch',
    'Bricolage Grotesque',
    'League Gothic',
    'Birthstone',
    'Gloria Hallelujah',
    'Rock Salt',
    'Mali',
    'Sanchez',
    'Merienda',
    'Jacques Francois Shadow',
    'Quicksand',
    'Courgette',
    'Bungee',
    'Chelsea Market',
    'Comfortaa',
    'Crafty Girls',
    'Croissant One',
    'Gluten',
    'Fredoka',
    'New Rocker',
    'Parkinsans',
    'Nothing You Could Do',
    'TikTok Sans',
];
export const PAIRINGS = [
    'sansSerif',
    'serif',
    'condensed',
    'chic',
    'geometric',
    'modern',
    'elegant',
    'urban',
    'luxury',
    'montserrat',
    'lora',
    'roboto',
    'merriweather',
    'cabin',
    'cardo',
    'dmSans',
    'ibmPlexSans',
    'manrope',
    'nunito',
    'raleway',
    'bebasNeue',
    'unbounded',
    'teko',
    'bbhHegarty',
    'michroma',
    'pacifico',
    'lobster',
    'chicle',
    'anton',
    'gfsNeohellenic',
    'cinzel',
    'lobsterTwo',
    'permanentMarker',
    'prata',
    'viga',
    'chango',
    'macondo',
    'homemadeApple',
    'lemonada',
    'shantellSans',
    'crushed',
    'boogaloo',
    'coiny',
    'concertOne',
    'rajdhani',
    'solway',
    'graduate',
    'alfaSlabOne',
    'jura',
    'unifrakturmaguntia',
    'grenzeGotisch',
    'bricolageGrotesque',
    'leagueGothic',
    'birthstone',
    'gloriaHallelujah',
    'rockSalt',
    'mali',
    'sanchez',
    'merienda',
    'jacquesFrancoisShadow',
    'quicksand',
    'courgette',
    'bungee',
    'chelseaMarket',
    'comfortaa',
    'craftyGirls',
    'croissantOne',
    'gluten',
    'fredoka',
    'newRocker',
    'parkinsans',
    'nothingYouCouldDo',
    'tiktokSans',
];
//# sourceMappingURL=index.js.map